import React, { useEffect, useRef, useState } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
import { buttonSizeToMidasClassName, buttonTypeToMidasClassName, } from '../Button/Button';
const dropdownKindToMidasClassName = (kind) => ({
    normal: undefined,
    danger: midas.danger,
    warning: midas.warning,
    success: midas.success,
    info: midas.info,
    style: midas.style,
    link: undefined,
}[kind]);
const Dropdown = ({ icon, text, values, tabIndex, invert, black, size, type, kind, dataCy, children, }) => {
    const nodeRef = useRef(null);
    const [isVisible, setVisible] = useState(false);
    const handleClickOutside = () => undefined;
    useEffect(() => () => {
        document.removeEventListener('click', handleClickOutside, false);
    }, []);
    const handleClickLink = () => {
        if (isVisible) {
            document.removeEventListener('click', handleClickOutside, false);
        }
        else {
            document.addEventListener('click', handleClickOutside, false);
        }
        setVisible(!isVisible);
    };
    return (React.createElement("div", { className: midas.dropdown, tabIndex: tabIndex, ref: nodeRef },
        !!values.length && (React.createElement("a", { tabIndex: 0, style: invert
                ? {
                    background: 'transparent',
                    color: 'white',
                    borderColor: type !== 'link' ? 'white' : undefined,
                }
                : black
                    ? {
                        background: 'transparent',
                        color: 'black',
                        borderColor: type !== 'link' ? 'black' : undefined,
                    }
                    : undefined, className: classNames(midas.button, size && buttonSizeToMidasClassName(size), type && buttonTypeToMidasClassName(type), kind && dropdownKindToMidasClassName(kind), midas.dropdownToggle), onTouchStart: undefined, onClick: handleClickLink, "data-cy": dataCy },
            icon && React.createElement("i", { className: classNames(midas.icon, midas[icon]) }),
            text,
            ' ',
            React.createElement("i", { style: {
                    borderTopColor: type === 'primary' || !!kind ? 'white' : undefined,
                }, className: classNames(midas.iconCaret, midas.ml5) }))),
        React.createElement("ul", { className: classNames(midas.menu) },
            children,
            values.map((item) => (React.createElement("li", { className: midas.menuItem }, item))))));
};
export default Dropdown;
